function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _wrapAsyncGenerator(e) {
  return function () {
    return new AsyncGenerator(e.apply(this, arguments));
  };
}
function AsyncGenerator(e) {
  var t, n;
  function resume(t, n) {
    try {
      var r = e[t](n),
        o = r.value,
        u = o instanceof _OverloadYield;
      Promise.resolve(u ? o.v : o).then(function (n) {
        if (u) {
          var i = "return" === t && o.k ? t : "next";
          if (!o.k || n.done) return resume(i, n);
          n = e[i](n).value;
        }
        settle(!!r.done, n);
      }, function (e) {
        resume("throw", e);
      });
    } catch (e) {
      settle(2, e);
    }
  }
  function settle(e, r) {
    2 === e ? t.reject(r) : t.resolve({
      value: r,
      done: e
    }), (t = t.next) ? resume(t.key, t.arg) : n = null;
  }
  this._invoke = function (e, r) {
    return new Promise(function (o, u) {
      var i = {
        key: e,
        arg: r,
        resolve: o,
        reject: u,
        next: null
      };
      n ? n = n.next = i : (t = n = i, resume(e, r));
    });
  }, "function" != typeof e["return"] && (this["return"] = void 0);
}
AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () {
  return this;
}, AsyncGenerator.prototype.next = function (e) {
  return this._invoke("next", e);
}, AsyncGenerator.prototype["throw"] = function (e) {
  return this._invoke("throw", e);
}, AsyncGenerator.prototype["return"] = function (e) {
  return this._invoke("return", e);
};
function _awaitAsyncGenerator(e) {
  return new _OverloadYield(e, 0);
}
function _asyncGeneratorDelegate(t) {
  var e = {},
    n = !1;
  function pump(e, r) {
    return n = !0, r = new Promise(function (n) {
      n(t[e](r));
    }), {
      done: !1,
      value: new _OverloadYield(r, 1)
    };
  }
  return e["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function () {
    return this;
  }, e.next = function (t) {
    return n ? (n = !1, t) : pump("next", t);
  }, "function" == typeof t["throw"] && (e["throw"] = function (t) {
    if (n) throw n = !1, t;
    return pump("throw", t);
  }), "function" == typeof t["return"] && (e["return"] = function (t) {
    return n ? (n = !1, t) : pump("return", t);
  }), e;
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function _asyncIterator(r) {
  var n,
    t,
    o,
    e = 2;
  for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) {
    if (t && null != (n = r[t])) return n.call(r);
    if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r));
    t = "@@asyncIterator", o = "@@iterator";
  }
  throw new TypeError("Object is not async iterable");
}
function AsyncFromSyncIterator(r) {
  function AsyncFromSyncIteratorContinuation(r) {
    if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
    var n = r.done;
    return Promise.resolve(r.value).then(function (r) {
      return {
        value: r,
        done: n
      };
    });
  }
  return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) {
    this.s = r, this.n = r.next;
  }, AsyncFromSyncIterator.prototype = {
    s: null,
    n: null,
    next: function next() {
      return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
    },
    "return": function _return(r) {
      var n = this.s["return"];
      return void 0 === n ? Promise.resolve({
        value: r,
        done: !0
      }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
    },
    "throw": function _throw(r) {
      var n = this.s["return"];
      return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
    }
  }, new AsyncFromSyncIterator(r);
}
var fs = require('fs');
var path = require('path');
var base58 = require('base-58');
var HEADER_SIZE = 389;
var BLOCK_NAME = /^(\d+)-([a-f0-9]{64})\.(sai|blk)$/i;

// Keep aligned with core Block::serialize_for_signature / serialize_for_net.
// Hash verification detects incompatible headers and misnamed files; it does
// not validate the signature, transactions or consensus validity of a block.
function parseHeader(header, size, filename, hashBytes) {
  var name = BLOCK_NAME.exec(path.basename(filename));
  if (!name || header.length !== HEADER_SIZE || size < HEADER_SIZE) {
    throw new Error('Unsupported block filename or truncated header');
  }
  var height = Number(header.readBigUInt64BE(4));
  var timestamp = Number(header.readBigUInt64BE(12));
  if (!Number.isSafeInteger(height) || height < 1 || !Number.isSafeInteger(timestamp)) {
    throw new Error('Block height or timestamp outside supported range');
  }
  var parent = header.subarray(20, 52);
  var preimage = Buffer.concat([header.subarray(4, 117), header.subarray(181, 213), header.subarray(221, 285)]);
  var hash = Buffer.from(hashBytes(Buffer.concat([parent, Buffer.from(hashBytes(preimage))]))).toString('hex');
  if (hash !== name[2].toLowerCase() || BigInt(name[1]) !== BigInt(timestamp)) {
    throw new Error('Block header does not match filename');
  }
  var tx_count = header.readUInt32BE(0);
  if (size < HEADER_SIZE + tx_count * 93) throw new Error('Truncated transaction body');
  var headerOnly = tx_count === 0 && height > 1 && size === HEADER_SIZE;
  return {
    hash: hash,
    height: height,
    parent_hash: parent.toString('hex'),
    timestamp: timestamp,
    creator: base58.encode(header.subarray(52, 85)),
    tx_count: headerOnly ? null : tx_count,
    size_bytes: headerOnly ? null : size,
    file_path: path.resolve(filename),
    body_available: !headerOnly,
    in_longest_chain: null
  };
}
function readBlockMetadata(_x2, _x3) {
  return _readBlockMetadata.apply(this, arguments);
} // Streaming traversal: no directory-sized array, no symlink traversal.
function _readBlockMetadata() {
  _readBlockMetadata = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(filename, hashBytes) {
    var handle, stat, header, _yield$handle$read, bytesRead;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.n = 1;
          return fs.promises.open(filename, 'r');
        case 1:
          handle = _context2.v;
          _context2.p = 2;
          _context2.n = 3;
          return handle.stat();
        case 3:
          stat = _context2.v;
          if (stat.isFile()) {
            _context2.n = 4;
            break;
          }
          throw new Error('Not a regular block file');
        case 4:
          header = Buffer.alloc(HEADER_SIZE);
          _context2.n = 5;
          return handle.read(header, 0, HEADER_SIZE, 0);
        case 5:
          _yield$handle$read = _context2.v;
          bytesRead = _yield$handle$read.bytesRead;
          return _context2.a(2, parseHeader(header.subarray(0, bytesRead), stat.size, filename, hashBytes));
        case 6:
          _context2.p = 6;
          _context2.n = 7;
          return handle.close();
        case 7:
          return _context2.f(6);
        case 8:
          return _context2.a(2);
      }
    }, _callee2, null, [[2,, 6, 8]]);
  }));
  return _readBlockMetadata.apply(this, arguments);
}
function blockFiles(_x) {
  return _blockFiles.apply(this, arguments);
}
function _blockFiles() {
  _blockFiles = _wrapAsyncGenerator(function (root) {
    var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return /*#__PURE__*/_regenerator().m(function _callee() {
      var directory, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, filename, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.n = 1;
            return _awaitAsyncGenerator(fs.promises.opendir(root));
          case 1:
            directory = _context.v;
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.p = 2;
            _iterator = _asyncIterator(directory);
          case 3:
            _context.n = 4;
            return _awaitAsyncGenerator(_iterator.next());
          case 4:
            if (!(_iteratorAbruptCompletion = !(_step = _context.v).done)) {
              _context.n = 8;
              break;
            }
            entry = _step.value;
            filename = path.join(root, entry.name);
            if (!(entry.isFile() && BLOCK_NAME.test(entry.name))) {
              _context.n = 6;
              break;
            }
            _context.n = 5;
            return filename;
          case 5:
            _context.n = 7;
            break;
          case 6:
            if (!(recursive && entry.isDirectory())) {
              _context.n = 7;
              break;
            }
            return _context.d(_regeneratorValues(_asyncGeneratorDelegate(_asyncIterator(blockFiles(filename, true)), _awaitAsyncGenerator)), 7);
          case 7:
            _iteratorAbruptCompletion = false;
            _context.n = 3;
            break;
          case 8:
            _context.n = 10;
            break;
          case 9:
            _context.p = 9;
            _t = _context.v;
            _didIteratorError = true;
            _iteratorError = _t;
          case 10:
            _context.p = 10;
            _context.p = 11;
            if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
              _context.n = 12;
              break;
            }
            _context.n = 12;
            return _awaitAsyncGenerator(_iterator["return"]());
          case 12:
            _context.p = 12;
            if (!_didIteratorError) {
              _context.n = 13;
              break;
            }
            throw _iteratorError;
          case 13:
            return _context.f(12);
          case 14:
            return _context.f(10);
          case 15:
            return _context.a(2);
        }
      }, _callee, null, [[11,, 12, 14], [2, 9, 10, 15]]);
    })();
  });
  return _blockFiles.apply(this, arguments);
}
module.exports = {
  HEADER_SIZE: HEADER_SIZE,
  BLOCK_NAME: BLOCK_NAME,
  parseHeader: parseHeader,
  readBlockMetadata: readBlockMetadata,
  blockFiles: blockFiles
};